export const videos = [
  {
    id: "interstellar-odyssey",
    title: "星际远征",
    type: "movie",
    region: "美国",
    year: "2024",
    tags: ["科幻", "冒险", "太空"],
    director: "诺亚·卡尔文",
    cast: ["艾登·里斯", "米拉·诺瓦克", "田中悠介"],
    description:
      "当地球资源濒临枯竭，一支由科学家与飞行员组成的远征队穿越虫洞，前往遥远星系寻找人类新的家园。他们在失重与孤独之间挣扎，也在时间扭曲中重新理解了爱与牺牲的意义。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20film%20poster%20of%20a%20lone%20astronaut%20standing%20before%20a%20colossal%20glowing%20planet%20vast%20starry%20nebula%20background%20dramatic%20rim%20light%20deep%20blue%20and%20amber%20color%20grading%20minimal%20bold%20layout%20ultra%20detailed%20premium%20movie%20artwork&width=400&height=600&seq=v-poster-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20cinematic%20film%20still%20of%20an%20astronaut%20floating%20before%20a%20giant%20ringed%20planet%20endless%20starfield%20and%20soft%20nebula%20glow%20deep%20blue%20tones%20with%20warm%20amber%20rim%20light%20epic%20high%20detail%20premium%20space%20artwork&width=1600&height=900&seq=v-backdrop-01&orientation=landscape",
    views: 3820000,
    rating: 9.2,
    duration: "148分钟",
    isFeatured: true,
    updatedAt: "2024-11-08",
  },
  {
    id: "silent-city",
    title: "沉默之城",
    type: "movie",
    region: "中国大陆",
    year: "2024",
    tags: ["悬疑", "犯罪", "剧情"],
    director: "陆晨光",
    cast: ["周砚", "许知微", "林止"],
    description:
      "一场连环失窃案让沉寂多年的老城区再度陷入恐慌。退休刑警与年轻记者在迷雾般的线索中追查真相，却发现每一条证据都指向自己不愿面对的过去。",
    poster:
      "https://readdy.ai/api/search-image?query=moody%20crime%20thriller%20movie%20poster%20of%20a%20rain%20soaked%20city%20street%20at%20night%20single%20silhouette%20under%20flickering%20lamp%20high%20contrast%20shadows%20cool%20blue%20tones%20with%20warm%20amber%20highlight%20minimal%20cinematic%20composition%20film%20grain&width=400&height=600&seq=v-poster-02&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20cinematic%20noir%20cityscape%20at%20night%20with%20heavy%20rain%20reflections%20distant%20lone%20figure%20and%20flickering%20street%20lamps%20moody%20blue%20shadow%20with%20faint%20amber%20glow%20high%20detail%20film%20still&width=1600&height=900&seq=v-backdrop-02&orientation=landscape",
    views: 2610000,
    rating: 8.7,
    duration: "132分钟",
    isFeatured: false,
    updatedAt: "2024-10-22",
  },
  {
    id: "mountain-sea",
    title: "山海旅人",
    type: "movie",
    region: "中国大陆",
    year: "2023",
    tags: ["奇幻", "冒险", "古装"],
    director: "白鹿川",
    cast: ["沈舟", "柳夜白", "阿吉"],
    description:
      "少年背负着族人的期望，踏上穿越山海秘境的旅程。他在迷雾与巨兽之间结识同伴，也逐渐揭开关于自己身世的古老传说。",
    poster:
      "https://readdy.ai/api/search-image?query=epic%20fantasy%20adventure%20movie%20poster%20of%20ancient%20misty%20mountains%20and%20a%20small%20traveler%20holding%20a%20glowing%20lantern%20mystical%20sea%20of%20clouds%20ethereal%20light%20deep%20teal%20and%20golden%20grading%20painterly%20detailed%20illustration%20cinematic&width=400&height=600&seq=v-poster-03&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20cinematic%20fantasy%20landscape%20of%20floating%20mountains%20above%20a%20sea%20of%20clouds%20with%20warm%20golden%20light%20and%20mystical%20mist%20small%20traveler%20silhouette%20deep%20teal%20tones%20high%20detail%20painterly%20art&width=1600&height=900&seq=v-backdrop-03&orientation=landscape",
    views: 1980000,
    rating: 8.4,
    duration: "126分钟",
    isFeatured: false,
    updatedAt: "2023-12-15",
  },
  {
    id: "midnight-train",
    title: "午夜列车",
    type: "movie",
    region: "韩国",
    year: "2023",
    tags: ["惊悚", "悬疑"],
    director: "郑河俊",
    cast: ["金度延", "朴世罗", "崔民浩"],
    description:
      "最后一班夜行列车驶入隧道后，乘客们发现车窗外的世界已不再熟悉。随着一个个车厢陷入诡异沉默，一场关于选择的生死考验悄然展开。",
    poster:
      "https://readdy.ai/api/search-image?query=tense%20thriller%20movie%20poster%20of%20a%20vintage%20train%20rushing%20through%20a%20dark%20tunnel%20blurred%20motion%20lights%20mysterious%20atmospheric%20fog%20cold%20blue%20palette%20with%20a%20hint%20of%20amber%20high%20contrast%20ultra%20detailed%20cinema%20art&width=400&height=600&seq=v-poster-04&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20cinematic%20scene%20of%20an%20old%20night%20train%20speeding%20through%20a%20dark%20foggy%20tunnel%20with%20blurred%20amber%20lights%20eerie%20atmosphere%20cold%20blue%20shadow%20high%20detail%20film%20still&width=1600&height=900&seq=v-backdrop-04&orientation=landscape",
    views: 1740000,
    rating: 8.1,
    duration: "118分钟",
    isFeatured: false,
    updatedAt: "2023-09-30",
  },
  {
    id: "time-silhouette",
    title: "时光剪影",
    type: "movie",
    region: "法国",
    year: "2022",
    tags: ["爱情", "剧情", "文艺"],
    director: "克莱尔·莫罗",
    cast: ["艾玛·洛朗", "卢卡斯·佩兰"],
    description:
      "一对恋人在海边小城相遇又错过，多年后因一卷旧胶片重新联系。影片用温柔而克制的镜头，讲述时间如何雕刻记忆与爱。",
    poster:
      "https://readdy.ai/api/search-image?query=romantic%20drama%20movie%20poster%20of%20two%20lovers%20silhouetted%20at%20sunset%20by%20a%20calm%20sea%20soft%20golden%20light%20nostalgic%20warm%20and%20muted%20blue%20tones%20minimal%20elegant%20composition%20gentle%20film%20grain%20premium%20cinema%20art&width=400&height=600&seq=v-poster-05&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20cinematic%20romantic%20scene%20of%20two%20people%20walking%20along%20a%20calm%20sea%20at%20golden%20sunset%20soft%20hazy%20light%20warm%20and%20muted%20blue%20tones%20gentle%20nostalgic%20high%20detail%20film%20still&width=1600&height=900&seq=v-backdrop-05&orientation=landscape",
    views: 1520000,
    rating: 8.6,
    duration: "112分钟",
    isFeatured: false,
    updatedAt: "2022-11-04",
  },
  {
    id: "steel-defense",
    title: "钢铁防线",
    type: "movie",
    region: "美国",
    year: "2024",
    tags: ["动作", "战争", "剧情"],
    director: "马库斯·格雷",
    cast: ["德里克·肖", "伊莲·沃德", "汤姆·里德"],
    description:
      "边境哨站遭遇突袭，一支疲惫的小队必须在增援到来前守住最后一道防线。炮火与忠诚之间，他们重新定义了什么是战友。",
    poster:
      "https://readdy.ai/api/search-image?query=action%20war%20movie%20poster%20of%20a%20battle%20hardened%20soldier%20against%20a%20burning%20industrial%20skyline%20dramatic%20smoke%20and%20sparks%20strong%20contrast%20steel%20blue%20and%20fiery%20amber%20accents%20bold%20dynamic%20hyper%20detailed%20cinematic%20art&width=400&height=600&seq=v-poster-06&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20cinematic%20war%20scene%20of%20soldiers%20advancing%20through%20smoke%20and%20sparks%20with%20a%20burning%20skyline%20behind%20steel%20blue%20and%20amber%20contrast%20dramatic%20high%20detail%20film%20still&width=1600&height=900&seq=v-backdrop-06&orientation=landscape",
    views: 3090000,
    rating: 8.3,
    duration: "140分钟",
    isFeatured: false,
    updatedAt: "2024-10-05",
  },
  {
    id: "neon-pursuit",
    title: "霓虹追猎",
    type: "movie",
    region: "日本",
    year: "2024",
    tags: ["科幻", "动作", "赛博朋克"],
    director: "高桥凌",
    cast: ["神谷司", "早见凛", "黑泽彻"],
    description:
      "在霓虹闪烁的高密度都市，一名赏金猎人接下最后一份委托，却卷入科技巨头与底层反抗者之间的庞大阴谋。",
    poster:
      "https://readdy.ai/api/search-image?query=cyberpunk%20action%20movie%20poster%20of%20a%20futuristic%20runner%20sprinting%20through%20neon%20lit%20streets%20motion%20trails%20and%20holographic%20glow%20vivid%20amber%20and%20cool%20accents%20over%20dark%20blue%20night%20energetic%20dynamic%20ultra%20detailed%20cinema%20style&width=400&height=600&seq=v-poster-07&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20cinematic%20cyberpunk%20city%20at%20night%20with%20glowing%20neon%20signs%20and%20rain%20slick%20streets%20a%20running%20figure%20with%20motion%20trails%20dark%20blue%20and%20amber%20high%20detail%20film%20still&width=1600&height=900&seq=v-backdrop-07&orientation=landscape",
    views: 3280000,
    rating: 8.5,
    duration: "124分钟",
    isFeatured: false,
    updatedAt: "2024-10-28",
  },
  {
    id: "the-journey-home",
    title: "归途",
    type: "movie",
    region: "中国大陆",
    year: "2023",
    tags: ["剧情", "家庭"],
    director: "沈知远",
    cast: ["何雨桐", "陈砚青", "小满"],
    description:
      "在外打拼多年的父亲带着女儿回乡过年，漫长的公路上，两代人从沉默走向理解。一段关于家、原谅与成长的温暖旅程。",
    poster:
      "https://readdy.ai/api/search-image?query=emotional%20family%20drama%20movie%20poster%20of%20a%20parent%20and%20child%20holding%20hands%20on%20an%20empty%20country%20road%20at%20dusk%20soft%20warm%20light%20muted%20earthy%20and%20gentle%20blue%20tones%20quiet%20minimal%20tender%20cinematic%20atmosphere&width=400&height=600&seq=v-poster-08&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20cinematic%20scene%20of%20a%20parent%20and%20child%20walking%20along%20an%20empty%20country%20road%20at%20soft%20dusk%20warm%20muted%20and%20gentle%20blue%20tones%20quiet%20tender%20high%20detail%20film%20still&width=1600&height=900&seq=v-backdrop-08&orientation=landscape",
    views: 1660000,
    rating: 8.9,
    duration: "110分钟",
    isFeatured: false,
    updatedAt: "2023-11-20",
  },
  {
    id: "deep-blue-silence",
    title: "深蓝沉默",
    type: "movie",
    region: "英国",
    year: "2022",
    tags: ["科幻", "悬疑", "惊悚"],
    director: "奥利弗·班克斯",
    cast: ["索菲·凯恩", "詹姆斯·霍尔特"],
    description:
      "一艘深海探测潜艇在执行任务时与母船失去联系。随着下潜深度增加，船员们逐渐发现，真正令人恐惧的并非深海本身。",
    poster:
      "https://readdy.ai/api/search-image?query=sci-fi%20mystery%20movie%20poster%20of%20a%20deep%20ocean%20submarine%20descending%20into%20darkness%20single%20searchlight%20beam%20mysterious%20glow%20deep%20navy%20blue%20palette%20with%20faint%20amber%20high%20contrast%20minimal%20ultra%20detailed%20cinema%20art&width=400&height=600&seq=v-poster-09&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20cinematic%20deep%20ocean%20scene%20of%20a%20submarine%20with%20a%20single%20searchlight%20beam%20in%20dark%20navy%20water%20faint%20amber%20glow%20mysterious%20tense%20high%20detail%20film%20still&width=1600&height=900&seq=v-backdrop-09&orientation=landscape",
    views: 1430000,
    rating: 8.2,
    duration: "120分钟",
    isFeatured: false,
    updatedAt: "2022-10-18",
  },
  {
    id: "changan-mist",
    title: "长安迷雾",
    type: "tv",
    region: "中国大陆",
    year: "2024",
    tags: ["古装", "悬疑", "权谋"],
    director: "李慕白",
    cast: ["萧景行", "苏晚棠", "赵无极"],
    description:
      "大唐年间，长安城接连发生离奇命案，年轻的司直与神秘女仵作联手追凶。朝堂权谋与市井迷雾交织，真相远比想象的更加惊心。",
    poster:
      "https://readdy.ai/api/search-image?query=ancient%20chinese%20costume%20mystery%20drama%20poster%20of%20a%20lantern%20lit%20old%20capital%20street%20with%20blurred%20figures%20and%20drifting%20fog%20elegant%20hanfu%20silhouette%20deep%20indigo%20and%20warm%20gold%20tones%20painterly%20detailed%20cinematic&width=400&height=600&seq=v-poster-10&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20cinematic%20ancient%20chinese%20capital%20street%20at%20night%20with%20glowing%20lanterns%20and%20drifting%20fog%20silhouettes%20of%20robed%20figures%20deep%20indigo%20and%20warm%20gold%20high%20detail%20film%20still&width=1600&height=900&seq=v-backdrop-10&orientation=landscape",
    views: 5210000,
    rating: 9.0,
    duration: "全36集",
    isFeatured: true,
    updatedAt: "2024-11-12",
  },
  {
    id: "urban-days",
    title: "都市浮生",
    type: "tv",
    region: "中国大陆",
    year: "2024",
    tags: ["都市", "职场", "剧情"],
    director: "顾清和",
    cast: ["温言", "孟晞", "高子谦"],
    description:
      "三位背景迥异的年轻人在同一栋写字楼里相遇，面对理想、现实与人际关系的拉扯。城市很大，他们都在寻找属于自己的位置。",
    poster:
      "https://readdy.ai/api/search-image?query=modern%20workplace%20drama%20series%20poster%20of%20a%20young%20professional%20walking%20through%20a%20glass%20skyscraper%20lobby%20city%20skyline%20at%20dusk%20cool%20blue%20and%20warm%20interior%20glow%20clean%20minimal%20premium%20cinematic%20photography%20style&width=400&height=600&seq=v-poster-11&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20cinematic%20urban%20scene%20of%20a%20glass%20office%20lobby%20with%20city%20skyline%20at%20dusk%20soft%20cool%20blue%20and%20warm%20interior%20glow%20modern%20clean%20high%20detail%20film%20still&width=1600&height=900&seq=v-backdrop-11&orientation=landscape",
    views: 3380000,
    rating: 8.5,
    duration: "全32集",
    isFeatured: false,
    updatedAt: "2024-10-16",
  },
  {
    id: "throne-of-power",
    title: "权谋之巅",
    type: "tv",
    region: "美国",
    year: "2023",
    tags: ["历史", "权谋", "剧情"],
    director: "爱德华·诺森",
    cast: ["理查德·王", "凯瑟琳·贝尔", "安东尼·科尔"],
    description:
      "帝国边境战火未熄，王座之下的暗流却更加凶险。贵族、将军与继承者各怀心思，在一场场博弈中书写权力与背叛的史诗。",
    poster:
      "https://readdy.ai/api/search-image?query=epic%20historical%20drama%20poster%20of%20a%20royal%20throne%20room%20with%20a%20cloaked%20ruler%20in%20shadow%20ornate%20columns%20and%20candlelight%20dramatic%20chiaroscuro%20lighting%20deep%20navy%20and%20burnished%20gold%20grand%20ultra%20detailed&width=400&height=600&seq=v-poster-12&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20cinematic%20royal%20throne%20hall%20with%20tall%20columns%20candlelight%20and%20a%20cloaked%20figure%20in%20shadow%20deep%20navy%20and%20burnished%20gold%20dramatic%20high%20detail%20film%20still&width=1600&height=900&seq=v-backdrop-12&orientation=landscape",
    views: 4120000,
    rating: 8.8,
    duration: "全24集",
    isFeatured: false,
    updatedAt: "2023-12-02",
  },
  {
    id: "youth-chronicle",
    title: "青春纪事",
    type: "tv",
    region: "中国大陆",
    year: "2023",
    tags: ["青春", "校园", "爱情"],
    director: "夏知秋",
    cast: ["林一诺", "邓南", "柳思思"],
    description:
      "高三那年，一群性格不同的少年在压力与梦想之间奔跑。友情、暗恋与成长，都在那个被阳光晒得发亮的夏天里悄悄发生。",
    poster:
      "https://readdy.ai/api/search-image?query=youth%20campus%20drama%20poster%20of%20students%20on%20a%20sunny%20school%20rooftop%20blue%20sky%20and%20blossoms%20bright%20hopeful%20light%20soft%20pastel%20and%20gentle%20blue%20tones%20airy%20minimal%20warm%20nostalgic%20cinematic%20feeling&width=400&height=600&seq=v-poster-13&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20cinematic%20school%20rooftop%20scene%20on%20a%20bright%20sunny%20day%20with%20students%20and%20blue%20sky%20soft%20pastel%20and%20gentle%20blue%20tones%20warm%20nostalgic%20high%20detail%20film%20still&width=1600&height=900&seq=v-backdrop-13&orientation=landscape",
    views: 2960000,
    rating: 8.3,
    duration: "全40集",
    isFeatured: false,
    updatedAt: "2023-08-21",
  },
  {
    id: "dark-river-files",
    title: "暗河档案",
    type: "tv",
    region: "中国大陆",
    year: "2024",
    tags: ["悬疑", "刑侦", "犯罪"],
    director: "罗云舟",
    cast: ["江野", "沈冰", "秦川"],
    description:
      "尘封多年的档案被重新打开，刑警队长与法医循着一条暗河般隐秘的线索，抽丝剥茧，揭开横跨十年的连环谜案。",
    poster:
      "https://readdy.ai/api/search-image?query=crime%20investigation%20series%20poster%20of%20a%20detective%20examining%20evidence%20under%20a%20single%20desk%20lamp%20in%20a%20dark%20office%20moody%20shadows%20cold%20blue%20with%20warm%20amber%20tense%20minimal%20gritty%20cinematic%20realism%20detailed&width=400&height=600&seq=v-poster-14&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20cinematic%20detective%20office%20at%20night%20with%20a%20desk%20lamp%20evidence%20board%20and%20moody%20shadows%20cold%20blue%20with%20warm%20amber%20tense%20gritty%20high%20detail%20film%20still&width=1600&height=900&seq=v-backdrop-14&orientation=landscape",
    views: 4680000,
    rating: 8.9,
    duration: "全28集",
    isFeatured: false,
    updatedAt: "2024-11-05",
  },
  {
    id: "stellar-station",
    title: "星际迷航站",
    type: "tv",
    region: "美国",
    year: "2023",
    tags: ["科幻", "太空", "冒险"],
    director: "海伦·卡特",
    cast: ["米格尔·桑托斯", "安娜·彼得罗娃", "李承佑"],
    description:
      "位于环行星轨道的中转站接收了一份来自未知文明的信号。站内多国科学家必须放下分歧，携手面对人类从未想象过的接触。",
    poster:
      "https://readdy.ai/api/search-image?query=space%20sci-fi%20series%20poster%20of%20a%20futuristic%20space%20station%20orbiting%20a%20giant%20ringed%20planet%20sleek%20hull%20glowing%20windows%20starlit%20void%20deep%20blue%20and%20cyan%20accents%20clean%20modern%20ultra%20detailed%20space%20art&width=400&height=600&seq=v-poster-15&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20cinematic%20space%20station%20orbiting%20a%20giant%20ringed%20planet%20with%20glowing%20windows%20against%20a%20starlit%20void%20deep%20blue%20and%20cyan%20accents%20high%20detail%20film%20still&width=1600&height=900&seq=v-backdrop-15&orientation=landscape",
    views: 3540000,
    rating: 8.6,
    duration: "全20集",
    isFeatured: true,
    updatedAt: "2023-11-27",
  },
  {
    id: "healers-heart",
    title: "医者仁心",
    type: "tv",
    region: "中国大陆",
    year: "2022",
    tags: ["医疗", "剧情", "都市"],
    director: "方静川",
    cast: ["岑溪", "叶知秋", "何嘉树"],
    description:
      "急诊科里每天都在上演生死时速。一群医生在有限的条件下守护生命，也在一次次抉择中直面自己的脆弱与坚持。",
    poster:
      "https://readdy.ai/api/search-image?query=medical%20drama%20series%20poster%20of%20a%20determined%20doctor%20in%20a%20hospital%20corridor%20soft%20daylight%20and%20clean%20lines%20calm%20blue%20and%20warm%20white%20tones%20hopeful%20minimal%20premium%20cinematic%20photography%20detailed&width=400&height=600&seq=v-poster-16&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20cinematic%20hospital%20corridor%20with%20soft%20daylight%20and%20clean%20lines%20a%20doctor%20walking%20calm%20blue%20and%20warm%20white%20tones%20hopeful%20high%20detail%20film%20still&width=1600&height=900&seq=v-backdrop-16&orientation=landscape",
    views: 2180000,
    rating: 8.4,
    duration: "全36集",
    isFeatured: false,
    updatedAt: "2022-09-14",
  },
  {
    id: "phantom-night",
    title: "幻夜物语",
    type: "tv",
    region: "日本",
    year: "2024",
    tags: ["奇幻", "悬疑", "动漫"],
    director: "新海遥",
    cast: ["羽岛悟", "藤崎凛", "小林千夏"],
    description:
      "在人与妖共存的幻夜之城，一位年轻的书商替人代写心愿，却总能引来意想不到的访客。每个夜晚，都是一段奇妙物语的开始。",
    poster:
      "https://readdy.ai/api/search-image?query=japanese%20fantasy%20mystery%20series%20poster%20of%20a%20lone%20figure%20in%20a%20lantern%20lit%20alley%20under%20a%20glowing%20moon%20drifting%20magical%20mist%20indigo%20and%20silver%20tones%20dreamlike%20detailed%20illustration%20cinematic%20anime%20style&width=400&height=600&seq=v-poster-17&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20cinematic%20japanese%20lantern%20lit%20alley%20at%20night%20under%20a%20glowing%20moon%20with%20drifting%20magical%20mist%20indigo%20and%20silver%20tones%20dreamlike%20high%20detail%20anime%20style&width=1600&height=900&seq=v-backdrop-17&orientation=landscape",
    views: 2760000,
    rating: 8.7,
    duration: "全12集",
    isFeatured: false,
    updatedAt: "2024-10-09",
  },
  {
    id: "starlight-stage",
    title: "星光舞台",
    type: "variety",
    region: "中国大陆",
    year: "2024",
    tags: ["音乐", "竞演", "选秀"],
    director: "综艺制作组",
    cast: ["主持：程一鸣", "导师：苏菲", "嘉宾：吴天野"],
    description:
      "来自不同背景的歌手同台竞演，用一首首作品讲述自己的故事。舞台之下是汗水与坚持，舞台之上是光芒万丈的高光时刻。",
    poster:
      "https://readdy.ai/api/search-image?query=energetic%20music%20competition%20show%20poster%20of%20a%20singer%20under%20a%20brilliant%20stage%20spotlight%20glowing%20stage%20beams%20and%20confetti%20vivid%20amber%20and%20deep%20blue%20stage%20lighting%20dynamic%20bold%20premium%20broadcast%20key%20art&width=400&height=600&seq=v-poster-18&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20cinematic%20concert%20stage%20with%20brilliant%20spotlights%20beams%20and%20confetti%20a%20singer%20silhouette%20vivid%20amber%20and%20deep%20blue%20stage%20lighting%20high%20detail%20broadcast%20still&width=1600&height=900&seq=v-backdrop-18&orientation=landscape",
    views: 6120000,
    rating: 8.8,
    duration: "每周五更新",
    isFeatured: true,
    updatedAt: "2024-11-15",
  },
  {
    id: "wild-survival",
    title: "荒野生存记",
    type: "variety",
    region: "中国大陆",
    year: "2024",
    tags: ["户外", "真人秀", "冒险"],
    director: "综艺制作组",
    cast: ["领队：郑岩", "嘉宾：谭雪", "嘉宾：罗一山"],
    description:
      "八位嘉宾被投放到无人荒野，仅携带有限装备，靠智慧与协作完成生存挑战。真实的疲惫、冲突与感动，都在荒野中自然发生。",
    poster:
      "https://readdy.ai/api/search-image?query=outdoor%20reality%20survival%20show%20poster%20of%20adventurers%20crossing%20a%20rugged%20mountain%20ridge%20at%20dawn%20dramatic%20clouds%20epic%20harsh%20landscape%20cool%20blue%20and%20warm%20sunrise%20tones%20cinematic%20documentary%20style%20detailed&width=400&height=600&seq=v-poster-19&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20cinematic%20rugged%20mountain%20ridge%20at%20dawn%20with%20dramatic%20clouds%20and%20small%20hikers%20crossing%20cool%20blue%20and%20warm%20sunrise%20tones%20epic%20high%20detail%20documentary%20still&width=1600&height=900&seq=v-backdrop-19&orientation=landscape",
    views: 4460000,
    rating: 8.5,
    duration: "每周六更新",
    isFeatured: false,
    updatedAt: "2024-11-02",
  },
  {
    id: "chef-battle",
    title: "厨神争霸",
    type: "variety",
    region: "中国大陆",
    year: "2023",
    tags: ["美食", "竞技", "真人秀"],
    director: "综艺制作组",
    cast: ["主持：何味", "评委：田川", "评委：林芝"],
    description:
      "顶尖厨师同台竞技，用限定食材在有限时间内完成惊艳之作。刀光与烟火之间，是对火候、创意与匠心的极致考验。",
    poster:
      "https://readdy.ai/api/search-image?query=food%20competition%20show%20poster%20of%20a%20chef%20plating%20a%20gourmet%20dish%20in%20a%20professional%20kitchen%20steam%20and%20sizzling%20wok%20warm%20amber%20lighting%20over%20deep%20blue%20background%20appetizing%20detailed%20premium%20broadcast%20key%20art&width=400&height=600&seq=v-poster-20&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20cinematic%20professional%20kitchen%20with%20steam%20and%20sizzling%20wok%20warm%20amber%20lighting%20over%20deep%20blue%20background%20appetizing%20high%20detail%20broadcast%20still&width=1600&height=900&seq=v-backdrop-20&orientation=landscape",
    views: 2870000,
    rating: 8.2,
    duration: "每周日更新",
    isFeatured: false,
    updatedAt: "2023-12-10",
  },
  {
    id: "world-wanderlust",
    title: "环球漫游记",
    type: "variety",
    region: "中国大陆",
    year: "2023",
    tags: ["旅行", "纪录", "人文"],
    director: "综艺制作组",
    cast: ["主持：安然", "嘉宾：路一鸣"],
    description:
      "两位主持人沿着海岸线与古道前行，探访不同城市的风景与人物。慢下来的旅程，让观众看见世界温柔而辽阔的一面。",
    poster:
      "https://readdy.ai/api/search-image?query=travel%20documentary%20show%20poster%20of%20a%20winding%20road%20through%20stunning%20coastal%20cliffs%20and%20turquoise%20sea%20golden%20hour%20light%20elegant%20color%20grading%20cinematic%20wide%20ultra%20detailed%20landscape%20photography&width=400&height=600&seq=v-poster-21&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20cinematic%20coastal%20cliffs%20with%20a%20winding%20road%20above%20turquoise%20sea%20at%20golden%20hour%20elegant%20color%20grading%20ultra%20detailed%20landscape%20still&width=1600&height=900&seq=v-backdrop-21&orientation=landscape",
    views: 1930000,
    rating: 8.6,
    duration: "每周四更新",
    isFeatured: false,
    updatedAt: "2023-10-26",
  },
  {
    id: "talk-night",
    title: "脱口秀之夜",
    type: "variety",
    region: "中国大陆",
    year: "2024",
    tags: ["脱口秀", "喜剧"],
    director: "综艺制作组",
    cast: ["主持：老周", "常驻：小北", "常驻：阿ken"],
    description:
      "一群脱口秀演员用幽默解构生活里的琐碎与荒诞。没有剧本，只有真诚的表达和意想不到的爆笑瞬间。",
    poster:
      "https://readdy.ai/api/search-image?query=comedy%20talk%20show%20poster%20of%20a%20host%20with%20a%20microphone%20on%20a%20sleek%20studio%20stage%20colorful%20spotlights%20and%20studio%20backdrop%20playful%20amber%20and%20deep%20blue%20lighting%20clean%20bold%20premium%20broadcast%20key%20art&width=400&height=600&seq=v-poster-22&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20cinematic%20sleek%20comedy%20studio%20stage%20with%20colorful%20spotlights%20and%20a%20mic%20stand%20playful%20amber%20and%20deep%20blue%20lighting%20clean%20high%20detail%20broadcast%20still&width=1600&height=900&seq=v-backdrop-22&orientation=landscape",
    views: 3980000,
    rating: 8.9,
    duration: "每周三更新",
    isFeatured: false,
    updatedAt: "2024-11-13",
  },
  {
    id: "escape-crew",
    title: "密室逃脱团",
    type: "variety",
    region: "中国大陆",
    year: "2023",
    tags: ["推理", "真人秀", "悬疑"],
    director: "综艺制作组",
    cast: ["团长：韩铮", "嘉宾：程惜", "嘉宾：丁舟"],
    description:
      "六位嘉宾被困在精心设计的主题密室中，需要在限定时间内破解谜题逃出生天。每一次线索背后，都藏着意想不到的机关与反转。",
    poster:
      "https://readdy.ai/api/search-image?query=mystery%20puzzle%20reality%20show%20poster%20of%20contestants%20inside%20a%20dim%20escape%20room%20with%20glowing%20clues%20suspenseful%20shadows%20cool%20blue%20tones%20with%20warm%20amber%20highlights%20intricate%20detailed%20cinematic%20composition&width=400&height=600&seq=v-poster-23&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20cinematic%20dim%20escape%20room%20interior%20with%20glowing%20clues%20and%20mysterious%20shadows%20cool%20blue%20tones%20with%20warm%20amber%20highlights%20intricate%20high%20detail%20still&width=1600&height=900&seq=v-backdrop-23&orientation=landscape",
    views: 2340000,
    rating: 8.3,
    duration: "每周一更新",
    isFeatured: false,
    updatedAt: "2023-11-19",
  },
  {
    id: "voice-storm",
    title: "声音风暴",
    type: "variety",
    region: "中国大陆",
    year: "2024",
    tags: ["音乐", "选秀", "竞演"],
    director: "综艺制作组",
    cast: ["导师：周岚", "导师：陈默", "主持人：夏禾"],
    description:
      "全国各地的素人歌手齐聚舞台，用声音打动四位导师。盲选、对决与成长，让每一个平凡的声音都有被听见的机会。",
    poster:
      "https://readdy.ai/api/search-image?query=singing%20talent%20show%20poster%20of%20a%20hopeful%20contestant%20singing%20on%20a%20grand%20stage%20with%20dramatic%20backlight%20floating%20light%20particles%20vivid%20amber%20and%20deep%20blue%20spotlight%20emotional%20bold%20premium%20broadcast%20key%20art&width=400&height=600&seq=v-poster-24&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20cinematic%20grand%20singing%20stage%20with%20dramatic%20backlight%20and%20floating%20light%20particles%20vivid%20amber%20and%20deep%20blue%20spotlight%20emotional%20high%20detail%20broadcast%20still&width=1600&height=900&seq=v-backdrop-24&orientation=landscape",
    views: 5090000,
    rating: 8.7,
    duration: "每周日更新",
    isFeatured: true,
    updatedAt: "2024-11-16",
  },
];

export const regionOptions = ["全部", "中国大陆", "美国", "韩国", "日本", "英国", "法国"];

export const yearOptions = ["全部", "2024", "2023", "2022", "2021", "2020及以前"];

export const sortOptions = [
  { key: "latest", label: "最新上线" },
  { key: "hot", label: "播放最多" },
  { key: "rating", label: "评分最高" },
];

export const tagsByType: Record<string, string[]> = {
  movie: ["全部", "科幻", "动作", "悬疑", "爱情", "剧情", "冒险", "犯罪", "奇幻"],
  tv: ["全部", "悬疑", "都市", "古装", "科幻", "青春", "犯罪", "历史", "奇幻"],
  variety: ["全部", "音乐", "竞技", "真人秀", "美食", "旅行", "脱口秀", "推理"],
};

export const categoryMeta = [
  {
    key: "movie",
    name: "电影",
    tagline: "海量最新电影资源",
    description: "院线新片、经典佳作与艺术电影，覆盖动作、科幻、悬疑、爱情等多种类型，满足不同观影口味。",
    icon: "ri-film-line",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20collage%20of%20a%20grand%20movie%20theater%20with%20warm%20amber%20screen%20glow%20and%20deep%20blue%20seats%20elegant%20dramatic%20lighting%20high%20detail%20premium%20photography&width=800&height=600&seq=cat-movie-1&orientation=landscape",
  },
  {
    key: "tv",
    name: "电视剧",
    tagline: "热播剧集一站追更",
    description: "古装、都市、悬疑、科幻等多品类剧集实时更新，从热播大剧到口碑黑马，一次看个够。",
    icon: "ri-tv-2-line",
    cover: "https://readdy.ai/api/search-image?query=cozy%20living%20room%20at%20night%20with%20a%20glowing%20television%20screen%20warm%20amber%20light%20over%20deep%20blue%20shadows%20modern%20minimal%20high%20detail%20premium%20photography&width=800&height=600&seq=cat-tv-1&orientation=landscape",
  },
  {
    key: "variety",
    name: "综艺",
    tagline: "精彩综艺轻松get",
    description: "音乐竞演、户外真人秀、美食与脱口秀，承包你的欢乐时光，每周准时更新。",
    icon: "ri-mic-line",
    cover: "https://readdy.ai/api/search-image?query=vibrant%20concert%20stage%20with%20colorful%20spotlights%20beams%20and%20confetti%20warm%20amber%20and%20deep%20blue%20stage%20lighting%20energetic%20high%20detail%20premium%20photography&width=800&height=600&seq=cat-variety-1&orientation=landscape",
  },
];